var _path, _path2, _path3, _g, _g2, _use;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    viewBox: "-27 -14 54 36",
    width: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-27-14h54v36h-54z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-6-14h12v36h-12z",
    fill: "#dc171d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-27-2h54v12h-54z",
    fill: "#012a87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#fff",
    transform: "scale(1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m0 0v1h.5z",
    transform: "matrix(.95105652 .30901699 -.30901699 .95105652 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.30901699 .95105652 -.95105652 .30901699 0 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.30901699 -.95105652 .95105652 .30901699 0 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.80901699 .58778525 -.58778525 -.80901699 0 0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.80901699 -.58778525 .58778525 -.80901699 0 0)",
    xlinkHref: "#b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(8 3.313708)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(3.313708 8)",
    xlinkHref: "#a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAn);
export default __webpack_public_path__ + "static/media/AN.0789bc58.svg";
export { ForwardRef as ReactComponent };